import React from "react"

import {IonButton, IonIcon} from "@ionic/react"
import {personCircleOutline, personCircleSharp} from "ionicons/icons"

import User from "@customTypes/User"
import {useHistory} from "react-router";

interface props {
    item: User
}

const ListItemButtonUsers: React.FC<props> = ({item}) => {

    const history = useHistory()

    const goToUserView = (ev: any, userId: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/users/' + userId)
    }

    return (
        <IonButton color="medium" fill="clear" size="large"
                   onClick={ (ev) => goToUserView(ev, item.id) }
                   style={{ 'minWidth': '80px', 'fontSize': '1rem', 'textTransform': 'lowercase' }}>
            <IonIcon slot="start" ios={personCircleOutline} md={personCircleSharp} />
            {item.counts?.usersUsed || 0}/{item.maxUsers !== null ? item.maxUsers : '?'}
        </IonButton>
    )
}

export default ListItemButtonUsers